var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.model
    ? _c(
        "w-card",
        { attrs: { "max-width": "700" } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("column-highlights")))]),
          _vm.column.Highlights.length == 0
            ? _c("div", { staticClass: "no-hightlights" }, [
                _vm._v(" " + _vm._s(_vm.$ct("no-highlights")) + " "),
              ])
            : _vm._e(),
          _c(
            "w-scroll-view",
            {
              attrs: {
                tag: "w-sortable",
                "tag-attributes": _vm.sortableAttributes,
              },
            },
            [
              _vm._l(_vm.column.Highlights, function (highlight, i) {
                return _c(
                  "w-list-item",
                  {
                    key: highlight.uid,
                    style: highlight.Style.getStyle(),
                    attrs: { "show-handle": "" },
                  },
                  [
                    _c("w-list-item-text", [
                      _vm._v(_vm._s(highlight.toString(_vm.model))),
                    ]),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("edit-highlight"),
                                expression: "$ct('edit-highlight')",
                              },
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.onEditCondition(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "pen" } })],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "w-list-item-action",
                      [
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("remove-highlight"),
                                expression: "$ct('remove-highlight')",
                              },
                            ],
                            staticClass: "danger",
                            on: {
                              click: function ($event) {
                                return _vm.removeHighlight(i)
                              },
                            },
                          },
                          [_c("w-fa", { attrs: { icon: "trash" } })],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      return _vm.addClicked()
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("add-highlight"))),
                  ]),
                ],
                1
              ),
            ],
            2
          ),
          _c(
            "w-card-actions",
            [
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "times" },
                  on: {
                    click: function ($event) {
                      return _vm.close()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.close")) + " ")]
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.toEditHighlight != null } },
            [
              _vm.toEditHighlight
                ? _c("app-highlight-edit", {
                    attrs: {
                      browse: _vm.browse,
                      value: _vm.toEditHighlight,
                      model: _vm.model,
                    },
                    on: {
                      input: function ($event) {
                        return _vm.onHighlightInput($event)
                      },
                      close: function ($event) {
                        _vm.toEditHighlight = null
                      },
                    },
                  })
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }